import { apiPost, API_BASE_URL, apiGet, apiPut, apiDelete } from './api';

// Helper function for GET requests


// Helper function for DELETE requests


// Helper function for PUT requests


// Get all keywords
export const getKeywords = async (accountId = null, token = null) => {
  let endpoint = '/keywords';
  if (accountId) {
    endpoint += `?accountId=${accountId}`;
  }
  return await apiGet(endpoint, token);
};

// Add a new keyword
export const addKeyword = async (keywordData, token = null) => {
  return await apiPost('/keywords', keywordData, token);
};

// Update a keyword
export const updateKeyword = async (id, keywordData, token = null) => {
  return await apiPut(`/keywords/${id}`, keywordData, token);
};

// Delete a keyword (soft delete)
export const deleteKeyword = async (id, token = null) => {
  return await apiDelete(`/keywords/${id}`, token);
};

// Get filtered keywords
export const getFilteredKeywords = async (filters, token = null) => {
  const queryParams = new URLSearchParams();
  
  if (filters.text) queryParams.append('text', filters.text);
  if (filters.minLikes) queryParams.append('minLikes', filters.minLikes);
  if (filters.minRetweets) queryParams.append('minRetweets', filters.minRetweets);
  if (filters.minViews) queryParams.append('minViews', filters.minViews);
  if (filters.accountId) queryParams.append('accountId', filters.accountId);
  
  return await apiGet(`/keywords/filter?${queryParams.toString()}`, token);
};